import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@src/components/Checkbox';
import './styles.scss';

export const Terms = ({ checked, invalid, onTermsClick, onChange }) => (
  <Checkbox
    invalid={invalid}
    label={
      <span>
        I accept the{' '}
        <a className="frank-terms-link" href="/terms" onClick={() => onTermsClick && onTermsClick()} target="_">
          terms
        </a>
      </span>
    }
    onChange={onChange}
    value={checked}
    wrapperClassName="frank-terms"
  />
);

Terms.propTypes = {
  checked: PropTypes.bool.isRequired,
  invalid: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onTermsClick: PropTypes.func,
};
